import { useState, useEffect, useRef, ReactNode } from 'react'
import * as S from './styles'

export type DropdownProps = {
  title: ReactNode
  children: ReactNode
  addRightSpace?: boolean
}

function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }
      handler(event)
    }
    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)
    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}

export const Dropdown = ({
  title,
  children,
  addRightSpace = false
}: DropdownProps) => {
  const ref = useRef()
  const [isOpen, setIsOpen] = useState(false)

  useOnClickOutside(ref, () => setIsOpen(false))
  return (
    <S.Wrapper ref={ref} isOpen={isOpen} addRightSpace={addRightSpace}>
      <S.Title onClick={() => setIsOpen(!isOpen)}>{title}</S.Title>
      <S.Content aria-hidden={!isOpen}>{children}</S.Content>
    </S.Wrapper>
  )
}
